module.exports = __webpack_public_path__ + "static/media/galeryFloating1.280cff43.jpg";